/*
 * wysiwyg web editor
 *
 * suneditor.js
 * Copyright 2017 JiHong Lee.
 * MIT license.
 */
'use strict';

import dialog from 'suneditor/src/plugins/modules/dialog';
import anchor from 'suneditor/src/plugins/modules/_anchor';
import component from 'suneditor/src/plugins/modules/component';
import resizing from 'suneditor/src/plugins/modules/resizing';
import fileManager from 'suneditor/src/plugins/modules/fileManager';
import getDrawExString from "./lang/drawImageEx";

export default {
    name: 'drawImageEx',
    display: 'dialog',
    add: function (core) {
        core.addModule([dialog, anchor, component, resizing, fileManager]);
        
        const options = core.options;
        const context = core.context;
        const contextImage = context.drawImageEx = {
            _infoList: [], // @Override fileManager
            _infoIndex: 0, // @Override fileManager
            _uploadFileLength: 0, // @Override fileManager
            focusElement: null, // @Override dialog // This element has focus when the dialog is opened.
            sizeUnit: options._imageSizeUnit,
            _linkElement: '',
            _altText: '',
            _align: 'none',
            _floatClassRegExp: '__se__float\\-[a-z]+',
            _v_src: {_linkValue: ''},
            svgDefaultSize: '30%',
            base64RenderIndex: 0,
            // @require @Override component
            _element: null,
            _cover: null,
            _container: null,
            // @Override resizing properties
            inputX: null,
            inputY: null,
            _element_w: 1,
            _element_h: 1,
            _element_l: 0,
            _element_t: 0,
            _defaultSizeX: 'auto',
            _defaultSizeY: 'auto',
            _origin_w: options.imageWidth === 'auto' ? '' : options.imageWidth,
            _origin_h: options.imageHeight === 'auto' ? '' : options.imageHeight,
            _proportionChecked: true,
            _resizing: options.imageResizing,
            _resizeDotHide: !options.imageHeightShow,
            _rotation: options.imageRotation,
            _alignHide: !options.imageAlignShow,
            _onlyPercentage: options.imageSizeOnlyPercentage,
            _ratio: false,
            _ratioX: 1,
            _ratioY: 1,
            _captionShow: true,
            _captionChecked: false,
            _caption: null,
            captionCheckEl: null,
            /** 그림판 변수 */
            painting: false,
            erasing: false,
        };

        /** image dialog */
        let image_dialog = this.setDialog(core);
        contextImage.modal = image_dialog;
        contextImage.imgInputFile = image_dialog.querySelector('._se_image_file');
        contextImage.imgUrlFile = image_dialog.querySelector('._se_image_url');
        contextImage.focusElement = image_dialog.querySelector('.se-btn-primary');
        contextImage.altText = image_dialog.querySelector('._se_image_alt');
        contextImage.captionCheckEl = image_dialog.querySelector('._se_image_check_caption');
        contextImage.previewSrc = image_dialog.querySelector('._se_tab_content_image .se-link-preview');

        contextImage.myCanvas = image_dialog.getElementsByClassName("myCanvas")
        /** add event listeners */
        //image_dialog.querySelector('.se-dialog-tabs').addEventListener('click', this.openTab.bind(core));
        image_dialog.querySelector('form').addEventListener('submit', this.submit.bind(core));
        if (contextImage.imgInputFile) image_dialog.querySelector('.se-file-remove').addEventListener('click', this._removeSelectedFiles.bind(contextImage.imgInputFile, contextImage.imgUrlFile, contextImage.previewSrc));
        if (contextImage.imgUrlFile) contextImage.imgUrlFile.addEventListener('input', this._onLinkPreview.bind(contextImage.previewSrc, contextImage._v_src, options.linkProtocol));
        if (contextImage.imgInputFile && contextImage.imgUrlFile) contextImage.imgInputFile.addEventListener('change', this._fileInputChange.bind(contextImage));

        const imageGalleryButton = image_dialog.querySelector('.__se__gallery');
        if (imageGalleryButton) imageGalleryButton.addEventListener('click', this._openGallery.bind(core));
        
        contextImage.proportion = {};
        contextImage.inputX = {};
        contextImage.inputY = {};

        /*
        if (options.imageResizing) {
            contextImage.proportion = image_dialog.querySelector('._se_image_check_proportion');
            contextImage.inputX = image_dialog.querySelector('._se_image_size_x');
            contextImage.inputY = image_dialog.querySelector('._se_image_size_y');
            contextImage.inputX.value = options.imageWidth;
            contextImage.inputY.value = options.imageHeight;
            
            contextImage.inputX.addEventListener('keyup', this.setInputSize.bind(core, 'x'));
            contextImage.inputY.addEventListener('keyup', this.setInputSize.bind(core, 'y'));

            contextImage.inputX.addEventListener('change', this.setRatio.bind(core));
            contextImage.inputY.addEventListener('change', this.setRatio.bind(core));
            contextImage.proportion.addEventListener('change', this.setRatio.bind(core));
            
            image_dialog.querySelector('.se-dialog-btn-revert').addEventListener('click', this.sizeRevert.bind(core));
        }

         */

        /** append html */
        context.dialog.modal.appendChild(image_dialog);


        /** 그림판 리스너 */
        const mobile = this.isMobile();
        const startDrawCallback = (event) => {
            event.preventDefault();
            context.drawImageEx.painting = true;
            this.startDraw(event, context.drawImageEx.erasing, mobile);
        };

        const endDrawCallback = (event) => {
            context.drawImageEx.painting = false;
            this.endDraw(event);
        };

        const drawCallback = (event) => {
            if (!context.drawImageEx.painting) return;
            event.preventDefault();
            this.draw(event, context.drawImageEx.erasing, mobile);

        };

        const canvas = contextImage.myCanvas[0];
        //canvas.addEventListener('mousedown', startDrawCallback);
        //canvas.addEventListener('mouseup', endDrawCallback);
        //canvas.addEventListener('mousemove', drawCallback);
        canvas.addEventListener(mobile ? 'touchstart' : 'mousedown', startDrawCallback);
        canvas.addEventListener(mobile ? 'touchend' : 'mouseup', endDrawCallback);
        canvas.addEventListener(mobile ? 'touchmove' : 'mousemove', drawCallback);


        const colorButtons = document.getElementsByName('color-options');
        const colorPicker = document.getElementById('colorPicker');
        const colorLabel = document.getElementById('colorLabel');
        const updateSampleCallback = () => {
            this.updateSample(context.drawImageEx.erasing);
        };

        // 각 라디오 버튼에 대해 클릭 이벤트 핸들러를 추가합니다.
        for (let i = 0; i < colorButtons.length; i++) {
            colorButtons[i].addEventListener('click', function() {
                // 선택된 값을 가져옵니다.
                const selectedValue = this.value;
                colorPicker.value = selectedValue;
                colorLabel.style.backgroundColor = selectedValue;
                updateSampleCallback();
            });
        }


        // 각 라디오 버튼에 대해 클릭 이벤트 핸들러를 추가합니다.
        const penButtons = document.getElementsByName('pen-options');
        for (let i = 0; i < penButtons.length; i++) {
            penButtons[i].addEventListener('click', function() {
                // 선택된 값을 가져옵니다.
                const selectedValue = this.value;
                if(selectedValue === "Pen")
                {
                    context.drawImageEx.erasing = false;
                    canvas.style.cursor = "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb24tdGFibGVyLXBlbmNpbCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTQgMjBoNGwxMC41IC0xMC41YTEuNSAxLjUgMCAwIDAgLTQgLTRsLTEwLjUgMTAuNXY0IiAvPjxsaW5lIHgxPSIxMy41IiB5MT0iNi41IiB4Mj0iMTcuNSIgeTI9IjEwLjUiIC8+PC9zdmc+'), auto";
                    updateSampleCallback();
                }
                else
                {
                    context.drawImageEx.erasing = true;
                    updateSampleCallback();
                }
            });
        }

        const lineWidthSelect = document.getElementById('lineWidthSelect');
        lineWidthSelect.addEventListener('change', updateSampleCallback);

        colorPicker.addEventListener('input', function() {
            updateSampleCallback();
        });

        // input 요소의 값이 변경될 때 실행되는 이벤트 핸들러
        colorPicker.addEventListener('change', function() {
            // 선택한 컬러 값을 가져와서 레이블의 배경색으로 설정
            colorLabel.style.backgroundColor = colorPicker.value;
            updateSampleCallback();
        });

        this.updateSample(false);


        var elements = document.querySelectorAll('[data-command="update"]');
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.display = 'none';
        }

        /** link event */
        core.plugins.anchor.initEvent.call(core, 'drawImageEx', image_dialog.querySelector('._se_tab_content_url'));
        contextImage.anchorCtx = core.context.anchor.caller.drawImageEx;

        /** empty memory */
        image_dialog = null;

    },

    /** dialog */
    setDialog: function (core) {
        const option = core.options;
        const lang = core.lang;
        const dialog = core.util.createElement('DIV');

        dialog.className = 'se-dialog-content se-dialog-image';
        dialog.style.display = 'none';

        let html = '' +
            '<div class="se-dialog-header">' +
                '<button tabindex="0" type="button" data-command="close" class="se-btn se-dialog-close" class="close" title="' + lang.dialogBox.close + '" aria-label="' + lang.dialogBox.close + '">' +
                    core.icons.cancel +
                '</button>' +
                '<span class="se-modal-title">' + getDrawExString("header_title", lang.code) + '</span>' +
            '</div>' +
   /*         '<div class="se-dialog-tabs">' +
                '<button type="button" class="_se_tab_link active" data-tab-link="image">' + lang.toolbar.image + '</button>' +
                '<button type="button" class="_se_tab_link" data-tab-link="url">' + lang.toolbar.link + '</button>' +
            '</div>' +

    */
            '<form method="post" enctype="multipart/form-data">' +
                '<div class="_se_tab_content _se_tab_content_image">' +
                    '<div class="se-dialog-body"><div style="border-bottom: 1px dashed #ccc;">';
        html += `<div class="grid-container">
                    <div class="grid-item item1">
        
                        <div class="pen-container">
                            <div class="pen-item">
                                <canvas id="lineSample" width="80" height="52"></canvas>
                            </div>
                            <div class="pen-item">
                                <div class="left">
                                    <div class="pen-radio">
                                        <input type="radio" id="Pen" name="pen-options" value="Pen" checked />
                                        <label for="Pen" id="penLabel">
                                            <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb24tdGFibGVyLXBlbmNpbCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTQgMjBoNGwxMC41IC0xMC41YTEuNSAxLjUgMCAwIDAgLTQgLTRsLTEwLjUgMTAuNXY0IiAvPjxsaW5lIHgxPSIxMy41IiB5MT0iNi41IiB4Mj0iMTcuNSIgeTI9IjEwLjUiIC8+PC9zdmc+" style="width:18px;height:18px;">
        
                                        </label>
                                    </div>
                                    <div class="pen-radio">
                                        <input type="radio" id="Eraser" name="pen-options" value="Eraser"/>
                                        <label for="Eraser">
                                            <img src="data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIHdpZHRoPSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTEuMTk2OCAyLjQzOTEzYy41ODU4LS41ODU3OSAxLjUzNTUtLjU4NTc5IDIuMTIxMyAwbDQuMjQyNiA0LjI0MjY0Yy41ODU4LjU4NTc4LjU4NTggMS41MzU1MyAwIDIuMTIxMzJsLTguMTk2ODcgOC4xOTY5MWg1LjEzNjA3Yy4yNzYxIDAgLjUuMjIzOS41LjVzLS4yMjM5LjUtLjUuNWgtNi42ODA0Yy0uNDA5NzkuMDIxNS0uODI2NzEtLjEyNDMtMS4xMzk3Mi0uNDM3M2wtNC4yNDI2NC00LjI0MjZjLS41ODU3OC0uNTg1OC0uNTg1NzgtMS41MzU1IDAtMi4xMjEzem0xLjQxNDIuNzA3MWMtLjE5NTMtLjE5NTI2LS41MTE4LS4xOTUyNi0uNzA3MSAwbC02LjM2NTY4IDYuMzY1NjggNC45NDk3OCA0Ljk0OTc5IDYuMzY1Ni02LjM2NTcyYy4xOTUzLS4xOTUyNi4xOTUzLS41MTE4NCAwLS43MDcxMXptLTIuODMwMTQgMTIuMDIyNTctNC45NDk3NS00Ljk0OTgtMS42ODY4NiAxLjY4NjljLS4xOTUyNi4xOTUyLS4xOTUyNi41MTE4IDAgLjcwNzFsNC4yNDI2NCA0LjI0MjZjLjE5NTI2LjE5NTMuNTExODQuMTk1My43MDcxMSAweiIgZmlsbD0iIzIxMjEyMSIvPjwvc3ZnPg==" style="width:18px;height:18px;"/>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="pen-item">
                                <select class="select_lineWidth" id="lineWidthSelect">
                                    <option value="1" selected>1px</option>
                                    <option value="2">2px</option>
                                    <option value="3" >3px</option>
                                    <optin value="4" >4px</optin>
                                    <option value="5" >5px</option>
                                    <option value="6">6px</option>
                                    <option value="8">8px</option>
                                    <option value="10">10px</option>
                                    <option value="12">12px</option>
                                    <option value="14">14px</option>
                                    <option value="16">16px</option>
                                    <option value="18">18px</option>
                                    <option value="20">20px</option>
                                    <!-- 다른 굵기를 필요에 따라 추가할 수 있습니다 -->
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="grid-item item">
                        <div class="color-container ">
                            <div class="color-item left">
                                <div class="color-radio">
                                    <label for="colorPicker" class="color-label" id="colorLabel">&nbsp;</label>
                                    <input type="color" id="colorPicker" class="color-input"/>
                                </div>
                            </div>
                            <div class="color-item top-right">
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt1" name="color-options" value="#000000" checked />
                                    <label for="colorOpt1" style="background-color:#000000">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt2" name="color-options" value="#7F7F7F">
                                        <label for="colorOpt2" style="background-color:#7F7F7F">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt3" name="color-options" value="#880015">
                                        <label for="colorOpt3" style="background-color:#880015">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt4" name="color-options" value="#ED1C24">
                                        <label for="colorOpt4" style="background-color:#ED1C24">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt5" name="color-options" value="#FF7F27">
                                        <label for="colorOpt5" style="background-color:#FF7F27">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt6" name="color-options" value="#FFF200">
                                        <label for="colorOpt6" style="background-color:#FFF200">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt7" name="color-options" value="#22B14C">
                                        <label for="colorOpt7" style="background-color:#22B14C">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt8" name="color-options" value="#00A2E8">
                                        <label for="colorOpt8" style="background-color:#00A2E8">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt9" name="color-options" value="#3F48CC">
                                        <label for="colorOpt9" style="background-color:#3F48CC">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt10" name="color-options" value="#A349A4">
                                        <label for="colorOpt10" style="background-color:#A349A4">&nbsp;</label>
                                </div>
                            </div>
                            <div class="color-item bottom-right">
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt11" name="color-options" value="#FFFFFF">
                                        <label for="colorOpt11" style="background-color:#FFFFFF">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt12" name="color-options" value="#C3C3C3">
                                        <label for="colorOpt12" style="background-color:#C3C3C3">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt13" name="color-options" value="#B97A57">
                                        <label for="colorOpt13" style="background-color:#B97A57">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt14" name="color-options" value="#FFAEC9">
                                        <label for="colorOpt14" style="background-color:#FFAEC9">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt15" name="color-options" value="#FFC90E">
                                        <label for="colorOpt15" style="background-color:#FFC90E">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt16" name="color-options" value="#EFE4B0">
                                        <label for="colorOpt16" style="background-color:#EFE4B0">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt17" name="color-options" value="#B5E61D">
                                        <label for="colorOpt17" style="background-color:#B5E61D">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt18" name="color-options" value="#99D9EA">
                                        <label for="colorOpt18" style="background-color:#99D9EA">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt19" name="color-options" value="#7092BE">
                                        <label for="colorOpt19" style="background-color:#7092BE">&nbsp;</label>
                                </div>
        
                                <div class="color-radio">
                                    <input type="radio" id="colorOpt20" name="color-options" value="#C8BFE7">
                                        <label for="colorOpt20" style="background-color:#C8BFE7">&nbsp;</label>
                                </div>
        
                            </div>
                        </div>
                    </div>
                    <div id="sketch_div" class="grid-item item2">
                        <canvas id="myCanvas" class="myCanvas">
                        </canvas>
                    </div>
                </div>`;
            html +=    '<div class="se-dialog-form se-dialog-form-footer">' +
                            '<label><input type="checkbox" class="se-dialog-btn-check _se_image_check_caption" />&nbsp;' + lang.dialogBox.caption + '</label>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="_se_tab_content _se_tab_content_url" style="display: none">' +
                    core.context.anchor.forms.innerHTML +
                '</div>' +
                '<div class="se-dialog-footer">' +
                    '<div' + (option.imageAlignShow ? '' : ' style="display: none"') + '>' +
                        '<label><input type="radio" name="suneditor_image_radio" class="se-dialog-btn-radio" value="none" checked>' + lang.dialogBox.basic + '</label>' +
                        '<label><input type="radio" name="suneditor_image_radio" class="se-dialog-btn-radio" value="left">' + lang.dialogBox.left + '</label>' +
                        '<label><input type="radio" name="suneditor_image_radio" class="se-dialog-btn-radio" value="center">' + lang.dialogBox.center + '</label>' +
                        '<label><input type="radio" name="suneditor_image_radio" class="se-dialog-btn-radio" value="right">' + lang.dialogBox.right + '</label>' +
                    '</div>' +
                    '<button type="submit" class="se-btn-primary" title="' + lang.dialogBox.submitButton + '" aria-label="' + lang.dialogBox.submitButton + '"><span>' + lang.dialogBox.submitButton + '</span></button>' +
                '</div>' +
            '</form>';

        dialog.innerHTML = html;

        return dialog;
    },

    _fileInputChange: function () {
        if (!this.imgInputFile.value) {
            this.imgUrlFile.removeAttribute('disabled');
            this.previewSrc.style.textDecoration = '';
        } else {
            this.imgUrlFile.setAttribute('disabled', true);
            this.previewSrc.style.textDecoration = 'line-through';
        }
    },

    _removeSelectedFiles: function (urlInput, previewSrc) {
        this.value = '';
        if (urlInput) {
            urlInput.removeAttribute('disabled');
            previewSrc.style.textDecoration = '';
        }
    },

    _openGallery: function () {
        this.callPlugin('imageGallery', this.plugins.imageGallery.open.bind(this, this.plugins.image._setUrlInput.bind(this.context.drawImageEx)), null);
    },

    _setUrlInput: function (target) {
        this.altText.value = target.alt;
        this._v_src._linkValue = this.previewSrc.textContent = this.imgUrlFile.value = target.src;
        this.imgUrlFile.focus();
    },

    _onLinkPreview: function (context, protocol, e) {
        const value = e.target.value.trim();
        context._linkValue = this.textContent = !value ? '' : (protocol && value.indexOf('://') === -1 && value.indexOf('#') !== 0) ? protocol + value : value.indexOf('://') === -1 ? '/' + value : value;
    },

    /**
     * @Override @Required fileManager
     */
    fileTags: ['img'],

    /**
     * @Override core, fileManager, resizing
     * @description It is called from core.selectComponent.
     * @param {Element} element Target element
     */
    select: function (element) {
        this.plugins.drawImageEx.onModifyMode.call(this, element, this.plugins.resizing.call_controller_resize.call(this, element, 'drawImageEx'));


        const lineBreakers = document.querySelectorAll('.se-line-breaker-component');

        // top 위치를 비교하여 가장 큰 객체를 추적하기 위한 변수를 초기화합니다.
        let maxTopElement = null;
        let maxTop = 0;
        // display가 none인 요소가 있는지 확인하기 위한 변수를 초기화합니다.
        let hasDisplayNone = false;

        // 0.5초 뒤에 코드를 실행합니다.
        setTimeout(() => {
            // 모든 객체를 순회하면서 top 위치를 비교합니다.
            for(let i =0; i< lineBreakers.length; i++)
            {
                const element = lineBreakers[i];
                const topPosition = element.getBoundingClientRect().top;

                const displayStyle = window.getComputedStyle(element).getPropertyValue('display');
                if (displayStyle === 'none') {
                    hasDisplayNone = true;
                    break;
                }

                // 현재 객체의 top 위치가 최대값보다 크다면 최대값을 갱신합니다.
                if (topPosition > maxTop) {
                    maxTop = topPosition;
                    maxTopElement = element;
                }


            }

            if (!hasDisplayNone)
            {
                // 최대 top 위치를 가진 객체에 마우스 다운 이벤트를 자동으로 발생시킵니다.
                if (maxTopElement) {
                    // 마우스 다운 이벤트를 생성합니다.
                    const mouseDownEvent = new MouseEvent('mousedown', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });

                    // 최대 top 위치를 가진 객체에 마우스 다운 이벤트를 디스패치합니다.
                    maxTopElement.dispatchEvent(mouseDownEvent);
                }
            }
        }, 0); // 0.5초를 밀리초 단위로 설정합니다.

    },

    /**
     * @Override fileManager, resizing
     */
    destroy: function (element) {
        const imageEl = element || this.context.drawImageEx._element;
        const imageContainer = this.util.getParentElement(imageEl, this.util.isMediaComponent) || imageEl;
        const dataIndex = imageEl.getAttribute('data-index') * 1;
        let focusEl = (imageContainer.previousElementSibling || imageContainer.nextElementSibling);
        
        const emptyDiv = imageContainer.parentNode;
        this.util.removeItem(imageContainer);
        this.plugins.drawImageEx.init.call(this);
        this.controllersOff();

        if (emptyDiv !== this.context.element.wysiwyg) this.util.removeItemAllParents(emptyDiv, function (current) { return current.childNodes.length === 0; }, null);

        // focus
        this.focusEdge(focusEl);
        
        // event
        this.plugins.fileManager.deleteInfo.call(this, 'drawImageEx', dataIndex, this.functions.onImageUpload);

        // history stack
        this.history.push(false);
    },

    /**
     * @Required @Override dialog
     */
    on: function (update) {
        const contextImage = this.context.drawImageEx;

        const canvas = contextImage.myCanvas[0];



        if (!update) {
            /*contextImage.inputX.value = contextImage._origin_w = this.options.imageWidth === contextImage._defaultSizeX ? '' : this.options.imageWidth;
            contextImage.inputY.value = contextImage._origin_h = this.options.imageHeight === contextImage._defaultSizeY ? '' : this.options.imageHeight;
            if (contextImage.imgInputFile && this.options.imageMultipleFile) contextImage.imgInputFile.setAttribute('multiple', 'multiple');
            */
            if(canvas)
            {
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);

            }

        } else {
            //if (contextImage.imgInputFile && this.options.imageMultipleFile) contextImage.imgInputFile.removeAttribute('multiple');

            if (canvas)
            {

                const imgDataUrl =  canvas.toDataURL('image/png');
                const img = new Image();
                img.src = imgDataUrl;
                //console.log(imgDataUrl);
            }
        }

        this.plugins.anchor.on.call(this, contextImage.anchorCtx, update);
    },

    /**
     * @Required @Override dialog
     */
    open: function () {
        this.plugins.dialog.open.call(this, 'drawImageEx', 'drawImageEx' === this.currentControllerName);
        const container = document.getElementById('sketch_div');
        //console.log(container.offsetWidth);
        if(container && container.offsetWidth > 0)
        {
            const canvas = document.getElementById('myCanvas');

            const bodyHeight = document.body.offsetHeight;
            canvas.width = container.offsetWidth;
            if (bodyHeight < 695)
            {
                canvas.height = bodyHeight - 400 ;
            }
            else
            {
                canvas.height = canvas.width ;
            }
        }






    },

    openTab: function (e) {
        const modal = this.context.drawImageEx.modal;
        const targetElement = (e === 'init' ? modal.querySelector('._se_tab_link') : e.target);

        if (!/^BUTTON$/i.test(targetElement.tagName)) {
            return false;
        }

        // Declare all variables
        const tabName = targetElement.getAttribute('data-tab-link');
        const contentClassName = '_se_tab_content';
        let i, tabContent, tabLinks;

        // Get all elements with class="tabcontent" and hide them
        tabContent = modal.getElementsByClassName(contentClassName);
        for (i = 0; i < tabContent.length; i++) {
            tabContent[i].style.display = 'none';
        }

        // Get all elements with class="tablinks" and remove the class "active"
        tabLinks = modal.getElementsByClassName('_se_tab_link');
        for (i = 0; i < tabLinks.length; i++) {
            this.util.removeClass(tabLinks[i], 'active');
        }

        // Show the current tab, and add an "active" class to the button that opened the tab
        modal.querySelector('.' + contentClassName + '_' + tabName).style.display = 'block';
        this.util.addClass(targetElement, 'active');

        // focus
        if (tabName === 'image' && this.context.drawImageEx.focusElement) {
            this.context.drawImageEx.focusElement.focus();
        } else if (tabName === 'url') {
            this.context.anchor.caller.image.urlInput.focus();
        }

        this.context.drawImageEx.focusElement.focus();

        return false;
    },

    submit: function (e) {
        const contextImage = this.context.drawImageEx;
        const imagePlugin = this.plugins.drawImageEx;

        e.preventDefault();
        e.stopPropagation();

        //contextImage._altText = contextImage.altText.value;
        contextImage._align = contextImage.modal.querySelector('input[name="suneditor_image_radio"]:checked').value;
        contextImage._captionChecked = contextImage.captionCheckEl.checked;
        if (contextImage._resizing) contextImage._proportionChecked = contextImage.proportion.checked;

        //이미지변환
        const canvas = document.getElementById('myCanvas');
        const ctx = canvas.getContext('2d');
        let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        let data = imageData.data;

        // 탐지한 경계를 저장할 변수를 초기화합니다.
        let minX = canvas.width;
        let minY = canvas.height;
        let maxX = 0;
        let maxY = 0;

        // 이미지가 있는 부분의 경계를 탐지합니다.
        for (let y = 0; y < canvas.height; y++) {
            for (let x = 0; x < canvas.width; x++) {
                let index = (y * canvas.width + x) * 4;
                let alpha = data[index + 3];
                if (alpha > 0) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
        }

        // 경계를 기반으로 이미지가 있는 부분만을 자릅니다.
        let width = maxX - minX + 10;
        let height = maxY - minY + 10;
        let croppedImageData = ctx.getImageData(minX, minY, width, height);

        // 자른 이미지를 새로운 캔버스에 그려서 이미지로 만듭니다.
        let croppedCanvas = document.createElement('canvas');
        croppedCanvas.width = width;
        croppedCanvas.height = height;
        let croppedCtx = croppedCanvas.getContext('2d');
        croppedCtx.putImageData(croppedImageData, 0, 0);
        const dataUrl = croppedCanvas.toDataURL('image/png');
        let arr = dataUrl.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        const imgFileBlob =  new Blob([u8arr], { type: mime });
        imgFileBlob.lastModifiedDate = new Date();
        imgFileBlob.name = "myCanvas.png";

        let imgFiles = [imgFileBlob];

        try {
            if (this.context.dialog.updateModal) {
                imagePlugin.update_image.call(this, false, true, false);
            }
            
            if (imgFiles && imgFiles.length > 0) {
                this.showLoading();
                imagePlugin.submitAction.call(this, imgFiles);
            }
        } catch (error) {
            this.closeLoading();
            throw Error('[SUNEDITOR.image.submit.fail] cause : "' + error.message + '"');
        } finally {
            this.plugins.dialog.close.call(this);
        }

        return false;
    },

    submitAction: function (fileList) {
        if (fileList.length === 0) return;

        let fileSize = 0;
        let files = [];
        for (let i = 0, len = fileList.length; i < len; i++) {
            if (/image/i.test(fileList[i].type)) {
                files.push(fileList[i]);
                fileSize += fileList[i].size;
            }
        }

        const limitSize = this.options.imageUploadSizeLimit;
        if (limitSize > 0) {
            let infoSize = 0;
            const imagesInfo = this.context.drawImageEx._infoList;
            for (let i = 0, len = imagesInfo.length; i < len; i++) {
                infoSize += imagesInfo[i].size * 1;
            }

            if ((fileSize + infoSize) > limitSize) {
                this.closeLoading();
                const err = '[SUNEDITOR.imageUpload.fail] Size of uploadable total images: ' + (limitSize/1000) + 'KB';
                if (typeof this.functions.onImageUploadError !== 'function' || this.functions.onImageUploadError(err, { 'limitSize': limitSize, 'currentSize': infoSize, 'uploadSize': fileSize }, this)) {
                    this.functions.noticeOpen(err);
                }
                return;
            }
        }

        const contextImage = this.context.drawImageEx;
        contextImage._uploadFileLength = files.length;
        
        const anchor = this.plugins.anchor.createAnchor.call(this, contextImage.anchorCtx, true);
        let wrapper = document.querySelector('.se-wrapper');
        let wrapperHeight = 0;
        // 요소가 존재하는지 확인합니다.
        if (wrapper) {
            // 요소의 높이를 가져옵니다.
            wrapperHeight = wrapper.offsetHeight;
        } else {
            console.error('se-wrapper 클래스명을 가진 요소를 찾을 수 없습니다.');
        }

        this.plugins.drawImageEx.getImageHeight(fileList[0])
            .then(height => {
                const info = {
                    anchor: anchor,
                    inputWidth: "auto",
                    inputHeight: height > wrapperHeight ?  `${wrapperHeight / 2}px` : "auto",
                    align: contextImage._align,
                    isUpdate: this.context.dialog.updateModal,
                    alt: contextImage._altText,
                    element: contextImage._element
                };

                if (typeof this.functions.onImageUploadBefore === 'function') {
                    const result = this.functions.onImageUploadBefore(files, info, this, function (data) {
                        if (data && this._w.Array.isArray(data.result)) {
                            this.plugins.drawImageEx.register.call(this, info, data);
                        } else {
                            this.plugins.drawImageEx.upload.call(this, info, data);
                        }
                    }.bind(this));

                    if (typeof result === 'undefined') return;
                    if (!result) {
                        this.closeLoading();
                        return;
                    }
                    if (this._w.Array.isArray(result) && result.length > 0) files = result;
                }

                this.plugins.drawImageEx.upload.call(this, info, files);
            })
            .catch(error => {
                console.error('오류 발생:', error);
            });
        /*
        const info = {
            anchor: anchor,
            inputWidth: "auto",
            inputHeight: "auto",
            align: contextImage._align,
            isUpdate: this.context.dialog.updateModal,
            alt: contextImage._altText,
            element: contextImage._element
        };

        if (typeof this.functions.onImageUploadBefore === 'function') {
            const result = this.functions.onImageUploadBefore(files, info, this, function (data) {
                if (data && this._w.Array.isArray(data.result)) {
                    this.plugins.drawImageEx.register.call(this, info, data);
                } else {
                    this.plugins.drawImageEx.upload.call(this, info, data);
                }
            }.bind(this));
            
            if (typeof result === 'undefined') return;
            if (!result) {
                this.closeLoading();
                return;
            }
            if (this._w.Array.isArray(result) && result.length > 0) files = result;
        }

        this.plugins.drawImageEx.upload.call(this, info, files);

         */
    },
    getImageHeight: async function(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = function(event) {
                const img = new Image();
                img.onload = function() {
                    resolve(img.height);
                };
                img.onerror = function(error) {
                    reject(error);
                };
                img.src = event.target.result;
            };
            reader.onerror = function(error) {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    },


    error: function (message, response) {
            this.closeLoading();
            if (typeof this.functions.onImageUploadError !== 'function' || this.functions.onImageUploadError(message, response, this)) {
                this.functions.noticeOpen(message);
                throw Error('[SUNEDITOR.plugin.image.error] response: ' + message);
            }
        },

    upload: function (info, files) {
        if (!files) {
            this.closeLoading();
            return;
        }
        if (typeof files === 'string') {
            this.plugins.drawImageEx.error.call(this, files, null);
            return;
        }

        const imageUploadUrl = this.options.imageUploadUrl;
        const filesLen = this.context.dialog.updateModal ? 1 : files.length;

        // server upload
        if (typeof imageUploadUrl === 'string' && imageUploadUrl.length > 0) {
            const formData = new FormData();
            for (let i = 0; i < filesLen; i++) {
                formData.append('file-' + i, files[i]);
            }
            this.plugins.fileManager.upload.call(this, imageUploadUrl, this.options.imageUploadHeader, formData, this.plugins.drawImageEx.callBack_imgUpload.bind(this, info), this.functions.onImageUploadError);
        } else { // base64
            this.plugins.drawImageEx.setup_reader.call(this, files, info.anchor, info.inputWidth, info.inputHeight, info.align, info.alt, filesLen, info.isUpdate);
        }
    },

    callBack_imgUpload: function (info, xmlHttp) {
        if (typeof this.functions.imageUploadHandler === 'function') {
            this.functions.imageUploadHandler(xmlHttp, info, this);
        } else {
            const response = JSON.parse(xmlHttp.responseText);
            if (response.errorMessage) {
                this.plugins.drawImageEx.error.call(this, response.errorMessage, response);
            } else {
                this.plugins.drawImageEx.register.call(this, info, response);
            }
        }
    },

    register: function (info, response) {
        const fileList = response.result;

        for (let i = 0, len = fileList.length, file; i < len; i++) {
            file = { name: fileList[i].name, size: fileList[i].size };
            if (info.isUpdate) {
                this.plugins.drawImageEx.update_src.call(this, fileList[i].url, info.element, file);
                break;
            } else {
                this.plugins.drawImageEx.create_image.call(this, fileList[i].url, info.anchor, info.inputWidth, info.inputHeight, info.align, file, info.alt);
            }
        }
        
        this.closeLoading();
    },

    setup_reader: function (files, anchor, width, height, align, alt, filesLen, isUpdate) {
        try {
            this.context.drawImageEx.base64RenderIndex = filesLen;
            const wFileReader = this._w.FileReader;
            const filesStack = [filesLen];
            this.context.drawImageEx.inputX.value = width;
            this.context.drawImageEx.inputY.value = height;
    
            for (let i = 0, reader, file; i < filesLen; i++) {
                reader = new wFileReader();
                file = files[i];
    
                reader.onload = function (reader, update, updateElement, file, index) {
                    filesStack[index] = { result: reader.result, file: file };

                    if (--this.context.drawImageEx.base64RenderIndex === 0) {
                        this.plugins.drawImageEx.onRender_imgBase64.call(this, update, filesStack, updateElement, anchor, width, height, align, alt);
                        this.closeLoading();
                    }
                }.bind(this, reader, isUpdate, this.context.drawImageEx._element, file, i);

                reader.readAsDataURL(file);
            }
        } catch (e) {
            this.closeLoading();
            throw Error('[SUNEDITOR.image.setup_reader.fail] cause : "' + e.message + '"');
        }
    },

    onRender_imgBase64: function (update, filesStack, updateElement, anchor, width, height, align, alt) {
        const updateMethod = this.plugins.drawImageEx.update_src;
        const createMethod = this.plugins.drawImageEx.create_image;
        
        for (let i = 0, len = filesStack.length; i < len; i++) {
            if (update) {
                this.context.drawImageEx._element.setAttribute('data-file-name', filesStack[i].file.name);
                this.context.drawImageEx._element.setAttribute('data-file-size', filesStack[i].file.size);
                updateMethod.call(this, filesStack[i].result, updateElement, filesStack[i].file);
            } else {
                createMethod.call(this, filesStack[i].result, anchor, width, height, align, filesStack[i].file, alt);
            }
        }
    },

    onRender_imgUrl: function (url) {
        if (!url) url = this.context.drawImageEx._v_src._linkValue;
        if (!url) return false;
        const contextImage = this.context.drawImageEx;

        try {
            const file = {name: url.split('/').pop(), size: 0};
            if (this.context.dialog.updateModal) this.plugins.drawImageEx.update_src.call(this, url, contextImage._element, file);
            else this.plugins.drawImageEx.create_image.call(this, url, this.plugins.anchor.createAnchor.call(this, contextImage.anchorCtx, true), contextImage.inputX.value, contextImage.inputY.value, contextImage._align, file, contextImage._altText);
        } catch (e) {
            throw Error('[SUNEDITOR.image.URLRendering.fail] cause : "' + e.message + '"');
        } finally {
            this.closeLoading();
        }
    },

    onRender_link: function (imgTag, anchor) {
        if (anchor) {
            anchor.setAttribute('data-image-link', 'image');
            imgTag.setAttribute('data-image-link', anchor.href);
            anchor.appendChild(imgTag);
            return anchor;
        }

        return imgTag;
    },

    /**
     * @Override resizing
     * @param {String} xy 'x': width, 'y': height
     * @param {KeyboardEvent} e Event object
     */
    setInputSize: function (xy, e) {
        if (e && e.keyCode === 32) {
            e.preventDefault();
            return;
        }

        this.plugins.resizing._module_setInputSize.call(this, this.context.drawImageEx, xy);
    },

    /**
     * @Override resizing
     */
    setRatio: function () {
        this.plugins.resizing._module_setRatio.call(this, this.context.drawImageEx);
    },

    /**
     * @Override fileManager
     */
    checkFileInfo: function () {
        /*const imagePlugin = this.plugins.drawImageEx;
        const contextImage = this.context.drawImageEx;

        const modifyHandler = function (tag) {
            imagePlugin.onModifyMode.call(this, tag, null);
            imagePlugin.openModify.call(this, true);
            // get size
            contextImage.inputX.value = "auto";
            contextImage.inputY.value = "auto";
            // get align
            const format = this.util.getFormatElement(tag);
            if (format) contextImage._align = format.style.textAlign || format.style.float;
            // link
            if (this.util.isAnchor(tag.parentNode) && !contextImage.anchorCtx.linkValue) contextImage.anchorCtx.linkValue = ' ';
            
            imagePlugin.update_image.call(this, true, false, true);
            imagePlugin.init.call(this);
        }.bind(this);

        this.plugins.fileManager.checkInfo.call(this, 'drawImageEx', ['img'], this.functions.onImageUpload, modifyHandler, true);

         */
    },

    /**
     * @Override fileManager
     */
    resetFileInfo: function () {
        this.plugins.fileManager.resetInfo.call(this, 'drawImageEx', this.functions.onImageUpload);
    },

    create_image: function (src, anchor, width, height, align, file, alt) {
        const imagePlugin = this.plugins.drawImageEx;
        const contextImage = this.context.drawImageEx;
        this.context.resizing._resize_plugin = 'drawImageEx';

        let oImg = this.util.createElement('IMG');
        oImg.src = src;
        oImg.alt = alt;
        oImg.setAttribute('data-rotate', '0');
        anchor = imagePlugin.onRender_link.call(this, oImg, anchor ?  anchor.cloneNode(false) : null);

        if (contextImage._resizing) {
            oImg.setAttribute('data-proportion', contextImage._proportionChecked);
        }

        const cover = this.plugins.component.set_cover.call(this, anchor);
        const container = this.plugins.component.set_container.call(this, cover, 'se-image-container');

        // caption
        if (contextImage._captionChecked) {
            contextImage._caption = this.plugins.component.create_caption.call(this);
            cover.appendChild(contextImage._caption);
        }

        contextImage._element = oImg;
        contextImage._cover = cover;
        contextImage._container = container;

        // set size
        imagePlugin.applySize.call(this, width, height);

        // align
        imagePlugin.setAlign.call(this, align, oImg, cover, container);

        oImg.onload = imagePlugin._image_create_onload.bind(this, oImg, contextImage.svgDefaultSize, container);
        if (this.insertComponent(container, true, true, true))
        {
            this.plugins.fileManager.setInfo.call(this, 'drawImageEx', oImg, this.functions.onImageUpload, file, true);
        }
        this.context.resizing._resize_plugin = '';
    },

    _image_create_onload: function (oImg, svgDefaultSize, container) {
        // svg exception handling
        if (oImg.offsetWidth === 0) this.plugins.drawImageEx.applySize.call(this, svgDefaultSize, '');
        if (this.options.mediaAutoSelect) {
            this.selectComponent(oImg, 'drawImageEx');
        } else {
            const line = this.appendFormatTag(container, null);
            if (line) this.setRange(line, 0, line, 0);
        }
    },

    update_image: function (init, openController, notHistoryPush) {
        const contextImage = this.context.drawImageEx;
        let imageEl = contextImage._element;
        let cover = contextImage._cover;
        let container = contextImage._container;
        let isNewContainer = false;

        if (cover === null) {
            isNewContainer = true;
            imageEl = contextImage._element.cloneNode(true);
            cover = this.plugins.component.set_cover.call(this, imageEl);
        }

        if (container === null) {
            cover = cover.cloneNode(true);
            imageEl = cover.querySelector('img');
            isNewContainer = true;
            container = this.plugins.component.set_container.call(this, cover, 'se-image-container');
        } else if (isNewContainer) {
            container.innerHTML = '';
            container.appendChild(cover);
            contextImage._cover = cover;
            contextImage._element = imageEl;
            isNewContainer = false;
        }

        // check size
        let changeSize;
        const x = this.util.isNumber(contextImage.inputX.value) ? contextImage.inputX.value + contextImage.sizeUnit : contextImage.inputX.value;
        const y = this.util.isNumber(contextImage.inputY.value) ? contextImage.inputY.value + contextImage.sizeUnit : contextImage.inputY.value;
        if (/%$/.test(imageEl.style.width)) {
            changeSize = x !== container.style.width || y !== container.style.height;
        } else {
            changeSize = x !== imageEl.style.width || y !== imageEl.style.height;
        }

        // alt
        imageEl.alt = contextImage._altText;
        
        // caption
        let modifiedCaption = false;
        if (contextImage._captionChecked) {
            if (!contextImage._caption) {
                contextImage._caption = this.plugins.component.create_caption.call(this);
                cover.appendChild(contextImage._caption);
                modifiedCaption = true;
            }
        } else {
            if (contextImage._caption) {
                this.util.removeItem(contextImage._caption);
                contextImage._caption = null;
                modifiedCaption = true;
            }
        }

        // link
        let isNewAnchor = null;
        const anchor = this.plugins.anchor.createAnchor.call(this, contextImage.anchorCtx, true);
        if (anchor) {
            if (contextImage._linkElement !== anchor || (isNewContainer && !container.contains(anchor))) {
                contextImage._linkElement = anchor.cloneNode(false);
                cover.insertBefore(this.plugins.drawImageEx.onRender_link.call(this, imageEl, contextImage._linkElement), contextImage._caption);
                isNewAnchor = contextImage._element;
            } else {
                contextImage._linkElement.setAttribute('data-image-link', 'image');
            }
        } else if (contextImage._linkElement !== null) {
            const imageElement = imageEl;
            imageElement.setAttribute('data-image-link', '');
            if (cover.contains(contextImage._linkElement)) {
                const newEl = imageElement.cloneNode(true);
                cover.removeChild(contextImage._linkElement);
                cover.insertBefore(newEl, contextImage._caption);
                contextImage._element = imageEl = newEl;
            }
        }

        let existElement = null;
        if (isNewContainer) {
            existElement = (this.util.isRangeFormatElement(contextImage._element.parentNode) || this.util.isWysiwygDiv(contextImage._element.parentNode)) ? 
                contextImage._element : 
                this.util.isAnchor(contextImage._element.parentNode) ? contextImage._element.parentNode : this.util.getFormatElement(contextImage._element) || contextImage._element;
                
            if (this.util.getParentElement(contextImage._element, this.util.isNotCheckingNode)) {
                existElement = isNewAnchor ? anchor : contextImage._element;
                existElement.parentNode.replaceChild(container, existElement);
            } else if (this.util.isListCell(existElement)) {
                const refer = this.util.getParentElement(contextImage._element, function (current) { return current.parentNode === existElement; });
                existElement.insertBefore(container, refer);
                this.util.removeItem(contextImage._element);
                this.util.removeEmptyNode(refer, null, true);
            } else if (this.util.isFormatElement(existElement)) {
                const refer = this.util.getParentElement(contextImage._element, function (current) { return current.parentNode === existElement; });
                existElement = this.util.splitElement(existElement, refer);
                existElement.parentNode.insertBefore(container, existElement);
                this.util.removeItem(contextImage._element);
                this.util.removeEmptyNode(existElement, null, true);
                if (existElement.children.length === 0) existElement.innerHTML = this.util.htmlRemoveWhiteSpace(existElement.innerHTML);
            } else {
                if (this.util.isFormatElement(existElement.parentNode)) {
                    const formats = existElement.parentNode;
                    formats.parentNode.insertBefore(container, existElement.previousSibling ? formats.nextElementSibling : formats);
                    if (contextImage.__updateTags.map(function (current) { return existElement.contains(current); }).length === 0) this.util.removeItem(existElement);
                } else {
                    existElement.parentNode.replaceChild(container, existElement);
                }
            }

            imageEl = container.querySelector('img');

            contextImage._element = imageEl;
            contextImage._cover = cover;
            contextImage._container = container;
        }

        if (isNewAnchor) {
            if (!isNewContainer) {
                this.util.removeItem(anchor);
            } else {
                this.util.removeItem(isNewAnchor);
                if (this.util.getListChildren(anchor, function (current) { return /IMG/i.test(current.tagName); }).length === 0) {
                    this.util.removeItem(anchor);
                }
            }
        }

        // transform
        if (modifiedCaption || (!contextImage._onlyPercentage && changeSize)) {
            if (!init && (/\d+/.test(imageEl.style.height) || (this.context.resizing._rotateVertical && contextImage._captionChecked))) {
                if (/%$/.test(contextImage.inputX.value) || /%$/.test(contextImage.inputY.value)) {
                    this.plugins.resizing.resetTransform.call(this, imageEl);
                } else {
                    this.plugins.resizing.setTransformSize.call(this, imageEl, this.util.getNumber(contextImage.inputX.value, 0), this.util.getNumber(contextImage.inputY.value, 0));
                }
            }
        }

        // size
        if (contextImage._resizing) {
            imageEl.setAttribute('data-proportion', contextImage._proportionChecked);
            if (changeSize) {
                this.plugins.drawImageEx.applySize.call(this);
            }
        }

        // align
        this.plugins.drawImageEx.setAlign.call(this, null, imageEl, null, null);

        // set imagesInfo
        if (init) {
            this.plugins.fileManager.setInfo.call(this, 'drawImageEx', imageEl, this.functions.onImageUpload, null, true);
        }

        if (openController) {
            this.selectComponent(imageEl, 'drawImageEx');
        }

        // history stack
        if (!notHistoryPush) this.history.push(false);
    },

    update_src: function (src, element, file) {
        element.src = src;
        this._w.setTimeout(this.plugins.fileManager.setInfo.bind(this, 'drawImageEx', element, this.functions.onImageUpload, file, true));
        this.selectComponent(element, 'drawImageEx');
    },

    /**
     * @Required @Override fileManager, resizing
     */
    onModifyMode: function (element, size) {
        if (!element) return;
        
        const contextImage = this.context.drawImageEx;
        contextImage._linkElement = contextImage.anchorCtx.linkAnchor = this.util.isAnchor(element.parentNode) ? element.parentNode : null;
        contextImage._element = element;
        contextImage._cover = this.util.getParentElement(element, 'FIGURE');
        contextImage._container = this.util.getParentElement(element, this.util.isMediaComponent);
        contextImage._caption = this.util.getChildElement(contextImage._cover, 'FIGCAPTION');
        contextImage._align =  element.getAttribute('data-align') || element.style.float || 'none';
        element.style.float = '';
        this.plugins.anchor.setCtx(contextImage._linkElement, contextImage.anchorCtx);

        if (size) {
            contextImage._element_w = size.w;
            contextImage._element_h = size.h;
            contextImage._element_t = size.t;
            contextImage._element_l = size.l;
        }

        let userSize = contextImage._element.getAttribute('data-size') || contextImage._element.getAttribute('data-origin');
        let w, h;
        if (userSize) {
            userSize = userSize.split(',');
            w = userSize[0];
            h = userSize[1];
        } else if (size) {
            w = size.w;
            h = size.h;
        }

        contextImage._origin_w = w || element.style.width || element.width || '';
        contextImage._origin_h = h || element.style.height || element.height || '';
    },

    /**
     * @Required @Override fileManager, resizing
     */
    openModify: function (notOpen) {
        const contextImage = this.context.drawImageEx;
        if (contextImage.imgUrlFile) {
            contextImage._v_src._linkValue = contextImage.previewSrc.textContent = contextImage.imgUrlFile.value = contextImage._element.src;
        }
        //contextImage._altText = contextImage.altText.value = contextImage._element.alt;
        (contextImage.modal.querySelector('input[name="suneditor_image_radio"][value="' + contextImage._align + '"]') || contextImage.modal.querySelector('input[name="suneditor_image_radio"][value="none"]')).checked = true;
        contextImage._align = contextImage.modal.querySelector('input[name="suneditor_image_radio"]:checked').value;
        contextImage._captionChecked = contextImage.captionCheckEl.checked = !!contextImage._caption;
        
        if (contextImage._resizing) {
            this.plugins.resizing._module_setModifyInputSize.call(this, contextImage, this.plugins.drawImageEx);
        }

        if (!notOpen) this.plugins.dialog.open.call(this, 'drawImageEx', true);
    },

    /**
     * @Override fileManager
     */
    applySize: function (w, h) {
        const contextImage = this.context.drawImageEx;

        if (!w) w = contextImage.inputX.value || "auto";
        if (!h) h = contextImage.inputY.value || "auto";


        if ((contextImage._onlyPercentage && !!w) || /%$/.test(w)) {
            this.plugins.drawImageEx.setPercentSize.call(this, w, h);
            return true;
        } else if ((!w || w === 'auto') && (!h || h === 'auto')) {
            this.plugins.drawImageEx.setAutoSize.call(this);
        } else {
            this.plugins.drawImageEx.setSize.call(this, w, h, false);
        }

        return false;
    },

    /**
     * @Override resizing
     */
    sizeRevert: function () {
        this.plugins.resizing._module_sizeRevert.call(this, this.context.drawImageEx);
    },

    /**
     * @Override resizing
     */
    setSize: function (w, h, notResetPercentage, direction) {
        const contextImage = this.context.drawImageEx;
        const onlyW = /^(rw|lw)$/.test(direction) && /\d+/.test(contextImage._element.style.height);
        const onlyH = /^(th|bh)$/.test(direction) && /\d+/.test(contextImage._element.style.width);

        if (!onlyH) {
            contextImage._element.style.width = this.util.isNumber(w) ? w + contextImage.sizeUnit : w;
            this.plugins.drawImageEx.cancelPercentAttr.call(this);
        }
        if (!onlyW) {
            contextImage._element.style.height = this.util.isNumber(h) ? h + contextImage.sizeUnit : /%$/.test(h) ? '' : h;
        }

        if (contextImage._align === 'center') this.plugins.drawImageEx.setAlign.call(this, null, null, null, null);
        if (!notResetPercentage) contextImage._element.removeAttribute('data-percentage');

        // save current size
        this.plugins.resizing._module_saveCurrentSize.call(this, contextImage);
    },

    /**
     * @Override resizing
     */
    setAutoSize: function () {
        const contextImage = this.context.drawImageEx;

        if (contextImage._caption) contextImage._caption.style.marginTop = '';
        this.plugins.resizing.resetTransform.call(this, contextImage._element);
        this.plugins.drawImageEx.cancelPercentAttr.call(this);

        contextImage._element.style.maxWidth = '';
        contextImage._element.style.width = '';
        contextImage._element.style.height = '';
        contextImage._cover.style.width = '';
        contextImage._cover.style.height = '';

        this.plugins.drawImageEx.setAlign.call(this, null, null, null, null);
        contextImage._element.setAttribute('data-percentage', 'auto,auto');

        // save current size
        this.plugins.resizing._module_saveCurrentSize.call(this, contextImage);
    },
    
    /**
     * @Override resizing
     */
    setOriginSize: function () {
        const contextImage = this.context.drawImageEx;
        contextImage._element.removeAttribute('data-percentage');

        this.plugins.resizing.resetTransform.call(this, contextImage._element);
        this.plugins.drawImageEx.cancelPercentAttr.call(this);

        const originSize = (contextImage._element.getAttribute('data-origin') || '').split(',');
        const w = originSize[0];
        const h = originSize[1];

        if (originSize) {
            if (contextImage._onlyPercentage || (/%$/.test(w) && (/%$/.test(h) || !/\d/.test(h)))) {
                this.plugins.drawImageEx.setPercentSize.call(this, w, h);
            } else {
                this.plugins.drawImageEx.setSize.call(this, w, h);
            }

            // save current size
            this.plugins.resizing._module_saveCurrentSize.call(this, contextImage);
        }
    },

    /**
     * @Override resizing
     */
    setPercentSize: function (w, h) {
        const contextImage = this.context.drawImageEx;
        h = !!h && !/%$/.test(h) && !this.util.getNumber(h, 0) ? this.util.isNumber(h) ? h + '%' : h : this.util.isNumber(h) ? h + contextImage.sizeUnit : (h || '');
        const heightPercentage = /%$/.test(h);

        contextImage._container.style.width = this.util.isNumber(w) ? w + '%' : w;
        contextImage._container.style.height = '';
        contextImage._cover.style.width = '100%';
        contextImage._cover.style.height = !heightPercentage ? '' : h;
        contextImage._element.style.width = '100%';
        contextImage._element.style.height = heightPercentage ? '' : h;
        contextImage._element.style.maxWidth = '';

        if (contextImage._align === 'center') this.plugins.drawImageEx.setAlign.call(this, null, null, null, null);

        contextImage._element.setAttribute('data-percentage', w + ',' + h);
        this.plugins.resizing.setCaptionPosition.call(this, contextImage._element);

        // save current size
        this.plugins.resizing._module_saveCurrentSize.call(this, contextImage);
    },

    /**
     * @Override resizing
     */
    cancelPercentAttr: function () {
        const contextImage = this.context.drawImageEx;
        
        contextImage._cover.style.width = '';
        contextImage._cover.style.height = '';
        contextImage._container.style.width = '';
        contextImage._container.style.height = '';

        this.util.removeClass(contextImage._container, this.context.drawImageEx._floatClassRegExp);
        this.util.addClass(contextImage._container, '__se__float-' + contextImage._align);

        if (contextImage._align === 'center') this.plugins.drawImageEx.setAlign.call(this, null, null, null, null);
    },

    /**
     * @Override resizing
     */
    setAlign: function (align, element, cover, container) {
        const contextImage = this.context.drawImageEx;
        
        if (!align) align = contextImage._align;
        if (!element) element = contextImage._element;
        if (!cover) cover = contextImage._cover;
        if (!container) container = contextImage._container;

        if (/%$/.test(element.style.width) && align === 'center') {
            container.style.minWidth = '100%';
            cover.style.width = container.style.width;
        } else {
            container.style.minWidth = '';
            cover.style.width = this.context.resizing._rotateVertical ? (element.style.height || element.offsetHeight) : ((!element.style.width || element.style.width === 'auto') ? '' : element.style.width || '100%');
        }

        if (!this.util.hasClass(container, '__se__float-' + align)) {
            this.util.removeClass(container, contextImage._floatClassRegExp);
            this.util.addClass(container, '__se__float-' + align);
        }
        
        element.setAttribute('data-align', align);
    },

    /**
     * @Override dialog
     */
    init: function () {
        const contextImage = this.context.drawImageEx;
        if (contextImage.imgInputFile) contextImage.imgInputFile.value = '';
        if (contextImage.imgUrlFile) contextImage._v_src._linkValue = contextImage.previewSrc.textContent = contextImage.imgUrlFile.value = '';
        if (contextImage.imgInputFile && contextImage.imgUrlFile) {
            contextImage.imgUrlFile.removeAttribute('disabled');
            contextImage.previewSrc.style.textDecoration = '';
        }

        //contextImage.altText.value = '';
        contextImage.modal.querySelector('input[name="suneditor_image_radio"][value="none"]').checked = true;
        contextImage.captionCheckEl.checked = false;
        contextImage._element = null;
        //this.plugins.drawImageEx.openTab.call(this, 'init');

        if (contextImage._resizing) {
            contextImage.inputX.value = "auto";
            contextImage.inputY.value = "auto";
            contextImage.proportion.checked = true;
            contextImage._ratio = false;
            contextImage._ratioX = 1;
            contextImage._ratioY = 1;
        }

        this.plugins.anchor.init.call(this, contextImage.anchorCtx);
    },

    /**그림판 함수*/
    startDraw:function (e, erasing, mobile){
        this.draw(e, erasing, mobile);
    },

    endDraw:function() {
        const canvas = document.getElementById('myCanvas');
        let ctx = canvas.getContext('2d');
        ctx.beginPath();
    },

    draw :function(e, erasing, mobile) {
        const lineWidthSelect = document.getElementById('lineWidthSelect');
        const colorPicker = document.getElementById('colorPicker');
        const canvas = document.getElementById('myCanvas');
        const ctx = canvas.getContext('2d');

        let x = 0;
        let y = 0;

        if (mobile)
        {
            const rect = canvas.getBoundingClientRect();
            x = e.touches[0].clientX  - canvas.offsetLeft - rect.left + 16.5;
            y = e.touches[0].clientY - canvas.offsetTop - (rect.top - canvas.offsetTop);
        }
        else {
            x = e.offsetX;
            y = e.offsetY;
        }

        let addX = mobile ? 0 : 3;
        let addY = mobile ? 0 : 20;

        if(erasing)
        {
            const width = this.calcEragerSize();// 지우개의 너비
            const height = width; // 지우개의 높이
            const calcX = mobile ? x - (width/2) : x+2;
            const calcY = mobile ? y - (height/2) : y+18;


            ctx.clearRect( calcX, calcY, width, height);
        }
        else
        {
            ctx.lineWidth = lineWidthSelect.value;
            ctx.lineCap = 'round';
            ctx.strokeStyle = colorPicker.value;

            ctx.lineTo(x+addX, y+addY);
            ctx.stroke();
            //ctx.beginPath();
            //ctx.moveTo(x+addX, y+addY);
        }
    },
    calcEragerSize:function()
    {
        const lineWidthSelect = document.getElementById('lineWidthSelect');
        return lineWidthSelect.value < 13 ? 13 : lineWidthSelect.value;
    },
    setEraserIcon:function()
    {
        const canvas = document.getElementById('myCanvas');
        const lineSample = document.getElementById('lineSample');
        const sampleCtx = lineSample.getContext('2d');

        const width 	= this.calcEragerSize();// 지우개의 너비
        const height 	= width; // 지우개의 높이
        const svgWidth 	= width > 22 ? width : 22;
        const svgHeight = height > 60 ? height : 60;
        const svgCode 	=  `<svg width="${svgWidth+5}" height="${svgHeight+18}" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><g class="layer"><title>Layer 1</title><path d="m11.2,2.44c0.58,-0.59 1.53,-0.59 2.12,0l4.24,4.24c0.59,0.59 0.59,1.54 0,2.12l-8.2,8.2l5.14,0c0.28,0 0.5,0.22 0.5,0.5s-0.22,0.5 -0.5,0.5l-6.68,0c-0.41,0.02 -0.83,-0.12 -1.14,-0.44l-4.24,-4.24c-0.59,-0.59 -0.59,-1.54 0,-2.12l8.76,-8.76zm1.41,0.71c-0.19,-0.2 -0.51,-0.2 -0.71,0l-6.36,6.36l4.95,4.95l6.36,-6.36c0.2,-0.2 0.2,-0.52 0,-0.71l-4.24,-4.24zm-2.83,12.02l-4.95,-4.95l-1.69,1.69c-0.19,0.19 -0.19,0.51 0,0.7l4.25,4.25c0.19,0.19 0.51,0.19 0.7,0l1.69,-1.69z" fill="#212121" id="svg_1" /><rect fill="white" stroke="#212121" height="${height}" id="svg_2" width="${width}" x="2" y="17.4" style="background-color: white;"/></g></svg>`;

        // SVG 코드를 base64로 인코딩
        const base64SVG = btoa(svgCode);

        // 데이터 URI 생성
        const dataURI = "data:image/svg+xml;base64," + base64SVG;


        let img = new Image();
        img.src =  dataURI;

        // Canvas에 이미지 그리기
        sampleCtx.clearRect(0, 0, lineSample.width, lineSample.height);
        img.onload = function() {
            sampleCtx.drawImage(img, (lineSample.width/2) - ((svgWidth)/2), (lineSample.height/2)- (svgHeight/2-10) );
        };

        canvas.style.cursor = `url('${dataURI}'), auto`;
    },
    updateSample:function(erasing) {
        if(erasing)
        {
            this.setEraserIcon();
        }
        else
        {
            const colorPicker = document.getElementById('colorPicker');
            const lineWidthSelect = document.getElementById('lineWidthSelect');
            const lineSample = document.getElementById('lineSample');
            const sampleCtx = lineSample.getContext('2d');
            sampleCtx.clearRect(0, 0, lineSample.width, lineSample.height);
            sampleCtx.beginPath();
            sampleCtx.moveTo(10, lineSample.height / 2);
            sampleCtx.lineTo(lineSample.width - 10, lineSample.height / 2);
            sampleCtx.strokeStyle = colorPicker.value;
            sampleCtx.lineWidth = lineWidthSelect.value;
            sampleCtx.stroke();
        }
    },
    convertToImage:function(){
        const canvas = document.getElementById('myCanvas');
        const ctx = canvas.getContext('2d');
        let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        let data = imageData.data;

        // 탐지한 경계를 저장할 변수를 초기화합니다.
        let minX = canvas.width;
        let minY = canvas.height;
        let maxX = 0;
        let maxY = 0;

        // 이미지가 있는 부분의 경계를 탐지합니다.
        for (let y = 0; y < canvas.height; y++) {
            for (let x = 0; x < canvas.width; x++) {
                let index = (y * canvas.width + x) * 4;
                let alpha = data[index + 3];
                if (alpha > 0) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
        }

        // 경계를 기반으로 이미지가 있는 부분만을 자릅니다.
        let width = maxX - minX + 10;
        let height = maxY - minY + 10;
        let croppedImageData = ctx.getImageData(minX, minY, width, height);

        // 자른 이미지를 새로운 캔버스에 그려서 이미지로 만듭니다.
        let croppedCanvas = document.createElement('canvas');
        croppedCanvas.width = width;
        croppedCanvas.height = height;
        let croppedCtx = croppedCanvas.getContext('2d');
        croppedCtx.putImageData(croppedImageData, 0, 0);
        const imgDataUrl =  croppedCanvas.toDataURL('image/png');
        return this.blobToFile(this.dataURLtoBlob(imgDataUrl), 'cropped_image.png');
    },
    resizeCanvas:function() {
        const canvas = document.getElementById('myCanvas');
        const container = document.getElementById('sketch_div');
        //console.log(container.offsetWidth);
        canvas.width = container.offsetWidth;
        canvas.height = canvas.width ;
    },
    isMobile:function() {

        const UserAgent = navigator.userAgent.toLowerCase();
        if( UserAgent.match(/iphone|ipod|ipad|android|windows ce|blackberry|symbian|windows phone|webos|opera mini|opera mobi|polaris|i mobile|lgtelecom|nokia|sonyericsson/i) != null
            || UserAgent.match(/lg|samsung/) != null)
        {
            return true;
        }
        else
        {
            const touchPoints = navigator.maxTouchPoints;
            if (touchPoints > 0)
            {
                return  true;
            }
        }
        return  false;
    }

};
